const texts = {
  title: ['限时代办','限時代辦','Time-limited delegate'],
  help: ['仅代办本队本场事务，不移交俱乐部。到期自动结束，由原领队继续管理。','僅代辦本隊本場事務，不移交俱樂部。到期自動結束，由原領隊繼續管理。','Event-team tasks only. Club ownership stays unchanged. Access ends automatically at the deadline.'],
  select: ['选择已确认成员','選擇已確認成員','Choose a confirmed member'],
  end: ['授权结束时间（本机时区）','授權結束時間（本機時區）','Access ends (device time zone)'],
  date: ['选择日期','選擇日期','Choose date'], time: ['选择时间','選擇時間','Choose time'],
  assign: ['发送代办邀请','發送代辦邀請','Send invitation'], accept: ['接受本场代办','接受本場代辦','Accept delegation'],
  revoke: ['结束代办','結束代辦','End delegation'],
  reason: ['管理员核实依据／更正原因','管理員核實依據／更正原因','Administrator verification / reason'],
  required: ['请选择成员及未来的结束时间','請選擇成員及未來的結束時間','Choose a member and a future deadline'],
  failed: ['暂时无法读取，请重试','暫時無法讀取，請重試','Could not load. Please retry.'],
  retry: ['刷新','重新整理','Refresh'], more: ['设置','設定','Set up'],
  NONE: ['未设置','未設定','Not set'], PENDING: ['等待本人接受','等待本人接受','Awaiting acceptance'],
  ACTIVE: ['代办中','代辦中','Active'], EXPIRED: ['已到期，原领队继续管理','已到期，原領隊繼續管理','Expired — original leader retains management'],
  REVOKED: ['已结束','已結束','Ended'], INVALID: ['已失效，请联系原领队','已失效，請聯絡原領隊','Invalid — contact the original leader'],
  noLeader: ['请先完成俱乐部与本场队伍的审核关联','請先完成俱樂部與本場隊伍的審核關聯','First approve the club and its event-team link'],
  confirmEnd: ['确认结束本场代办？','確認結束本場代辦？','End this event delegation?'],
  history: ['授权记录','授權記錄','Authorization history'],
  saved: ['已保存','已儲存','Saved']
}
function delegationText(locale) {
  const raw=String(locale||'').toLowerCase(), index=/^en/.test(raw)?2:/^zh[-_](hant|tw|hk|mo)/.test(raw)?1:0
  return Object.fromEntries(Object.entries(texts).map(([key,value])=>[key,value[index]]))
}
function deadline(date,time) {
  if(!/^\d{4}-\d{2}-\d{2}$/.test(date||'') || !/^\d{2}:\d{2}$/.test(time||'')) return null
  const [y,m,d]=date.split('-').map(Number),[h,min]=time.split(':').map(Number)
  const value=new Date(y,m-1,d,h,min,0,0)
  return value.getFullYear()===y && value.getMonth()===m-1 && value.getDate()===d && value.getHours()===h && value.getMinutes()===min?value.getTime():null
}
function formatDeadline(value) {
  if(!Number.isFinite(Number(value)) || !value) return ''
  const d=new Date(Number(value)),pad=n=>String(n).padStart(2,'0')
  return `${d.getFullYear()}-${pad(d.getMonth()+1)}-${pad(d.getDate())} ${pad(d.getHours())}:${pad(d.getMinutes())}`
}
module.exports={delegationText,deadline,formatDeadline}
